import React, { useState } from "react";
import "./Contact.css";
import MinimalNavbar from "./MinimalNavbar";
import "./styles/backgrounds.css";


const Contact = () => {
  const [submitted, setSubmitted] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: ""
  });

  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

const handleFormSubmit = async (e) => {
  e.preventDefault();

  if (!formData.name || !formData.email || !formData.message) {
    alert("Merci de remplir tous les champs.");
    return;
  }

  try {
    const response = await fetch("https://formspree.io/f/meokgkgg", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        name: formData.name,
        email: formData.email,
        message: formData.message
      })
    });

    if (response.ok) {
      setSubmitted(true);
      setFormData({ name: "", email: "", message: "" });
    } else {
      alert("Erreur lors de l’envoi. Veuillez réessayer.");
    }
  } catch (error) {
    alert("Erreur réseau. Vérifiez votre connexion.");
  }
};


  return (
    <>
      <div className="navbar-container">
        <MinimalNavbar />
      </div>
<div className="page-background other-background">

        <div className="contact-grid-wrapper">
          <div className="contact-bloc">
            <h1 className="contact-title">CONTACT</h1>
            <p className="contact-subtext">Une question, une remarque ? Écrivez-nous via ce formulaire ✉️</p>
            {!submitted ? (
              <form onSubmit={handleFormSubmit} className="contact-form">
                <input
                  type="text"
                  name="name"
                  placeholder="Votre nom"
                  value={formData.name}
                  onChange={handleFormChange}
                />
                <input
                  type="email"
                  name="email"
                  placeholder="Votre email"
                  value={formData.email}
                  onChange={handleFormChange}
                />
                <textarea
                  name="message"
                  placeholder="Votre message"
                  rows="5"
                  value={formData.message}
                  onChange={handleFormChange}
                />
                <button type="submit" className="start-button">Envoyer</button>
              </form>
            ) : (
              <div className="contact-thanks">
                <h2>Merci pour votre message !</h2>
                <p>Nous reviendrons vers vous rapidement.</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Contact;
